//Mobile
const ldRgbGalerryMobileImgs = document.getElementsByClassName("ld-rgb__gallery-img-mob");
const ldRgbCarouselMobile = document.getElementById("ldRgbCarouselMobile");
const ldRgbCarouselMobileCloseBtn = document.getElementById("ldRgbCarouselMobileCloseBtn");

ldRgbCarouselMobileCloseBtn.onclick = () => {
  ldRgbCarouselMobile.style.top = "-100%";
};
const ldRgbCarouselGalleryMob = new Flickity(".nam-flickity-gallery-mobile");
for (let i = 0; i < ldRgbGalerryMobileImgs.length; i++) {
  const element = ldRgbGalerryMobileImgs[i];
  element.onclick = () => {
    ldRgbCarouselMobile.style.top = "0";
    ldRgbCarouselGalleryMob.select(i);
  };
}

//Desktop
const ldRgbGalerryImgs = document.getElementsByClassName("ld-rgb__gallery-img");
const ldRgbCarousel = document.getElementById("ldRgbCarousel");
const ldRgbCarouselCloseBtn = document.getElementById("ldRgbCarouselCloseBtn")

ldRgbCarouselCloseBtn.onclick = () => {
    ldRgbCarousel.style.top = "-100%";
}
const flkty = new Flickity('.nam-carousel-gallery');

for (let i = 0; i < ldRgbGalerryImgs.length; i++) {
  const element = ldRgbGalerryImgs[i];
  element.onclick = () => {
    ldRgbCarousel.style.top = "0";
    flkty.select( i );
  };
}
